import TitledCard from './TitledCard'
export default TitledCard
